
if (!customElements.get("swiper-slider")) {
  class SwiperSlider extends HTMLElement {
      constructor() {
          super();

          var _this = this;
          this.isThumbnails = false;

          // swiper container
          this.swiperContainer = this.querySelector(".swiper-container");
          this.config = this.swiperContainer?.dataset || {};

          // Check thumbnails available or not
          if (this.config.thumbs) {
              this.isThumbnails = true;
          }

          // wait for swiper slider
          this.waitForSwiper(function () {
              // If thumbnails available
              _this.initSwiperWithThumbs(_this.swiperContainer);
          });
      }

      // Wit for swiper slider
      waitForSwiper(trigger) {
          var interval = setInterval(function () {
              if (typeof Swiper !== "undefined") {
                  clearInterval(interval);
                  trigger();
              }
          }, 50);
          setTimeout(function () {
              clearInterval(interval);
          }, 15000);
      }

      // Thumbnail configuration
      thumbConfig(thumbConfig) {
          var config = {
              slidesPerView: 3,
              spaceBetween: 12,
              centeredSlides: false,
              grabCursor: true,
              freeMode: false,
              mousewheel: false,
              slideToClickedSlide: true,
              slidesPerColumn: 1,
              slidesPerColumnFill: "column",
              loop: true,
              a11y: false,
              keyboard: {
                  enabled: true,
              },
              direction: "horizontal",
          };

          // Loop
          if (thumbConfig.loop == "true") {
              config.loop = true;
          } else {
              config.loop = false;
          }

          // Slide per view
          if (thumbConfig?.slidesPerView > 1) {
              config.slidesPerView = thumbConfig.slidesPerView;
          }

          // direction
          if (thumbConfig.direction) {
              config.direction = thumbConfig.direction;
          }

          // Breakpoints
          if (thumbConfig.breakpoints) {
              config.breakpoints = JSON.parse(thumbConfig.breakpoints);
          }

          //autoplay
          if (thumbConfig.autoplay == "true") {
              config.autoplay = {
                  delay: thumbConfig.delay || 5000,
              };
          }
          // allowTouchMove

          if (thumbConfig.allowTouchMove == "true") {
              config.allowTouchMove = true;
          } else {
              config.allowTouchMove = false;
          }

          return config;
      }

      // Gallery slider configuration
      galleryConfiguration(galleryConfig, thumbs) {
          var config = {
              slidesPerView: 1,
              spaceBetween: 12,
              centeredSlides: false,
              loop: true,
              a11y: false,
              slideToClickedSlide: false,
              direction: "horizontal",
              thumbs: {},
              pagination: {
                  el: "",
                  clickable: true,
              },
              navigation: {
                  nextEl: "",
                  prevEl: "",
              },
              on: {
                  init: function (resp) {

                      resp.el.parentElement.parentElement.classList.add('slideCount-' + resp.slides.length);

                  }, 
                  slideChange: function (e, i) {
                      function videoClick() {
                          if (document.querySelectorAll('.videoWrapper video')) {
                              document.querySelectorAll('.videoWrapper video').forEach(function (video) {
                                  video.pause();
                              });
                          }

                          if (document.querySelectorAll('.VideoSliderContainer video').length > 0 && e.el.closest('.VideoSliderContainer')) {
                              document.querySelectorAll('.VideoSliderContainer video')?.forEach(function (video) {
                                  video.pause();
                              });
                              document.querySelectorAll('.videoWrapper').forEach(function (item) {
                                  item.classList.remove('playing');
                              });
                              document.querySelector('.VideoSliderContainer .swiper-wrapper .swiper-slide:nth-child(' + (e.activeIndex + 1) + ') .videoWrapper')?.classList.add('playing');
                              var currentVideo = document.querySelector('.VideoSliderContainer .swiper-wrapper .swiper-slide:nth-child(' + (e.activeIndex + 1) + ') video');
                              if (currentVideo) {
                                  currentVideo.volume = .5;
                                  currentVideo.play();
                              }
                          }

                          // Resetting the 'data-clicked' attribute after the actions are performed
                          document.querySelectorAll('.videoSliderSection .slider-navigation .swiper-button-prev, .videoSliderSection .slider-navigation .swiper-button-next, .videoWrapper video').forEach(function (element) {
                              element.removeAttribute('data-clicked');
                          });
                      }

                      // Adding event listeners with a check for the 'data-clicked' attribute
                      document.querySelector('.videoSliderSection .slider-navigation .swiper-button-prev')?.addEventListener('click', function (event) {
                          if (!this.getAttribute('data-clicked')) {
                              this.setAttribute('data-clicked', 'true');
                              videoClick();
                          }
                      });

                      document.querySelector('.videoSliderSection .slider-navigation .swiper-button-next')?.addEventListener('click', function (event) {
                          if (!this.getAttribute('data-clicked')) {
                              this.setAttribute('data-clicked', 'true');
                              videoClick();
                          }
                      });

                      document.querySelector('.videoWrapper video')?.addEventListener('click', function (event) {
                          if (!this.getAttribute('data-clicked')) {
                              this.setAttribute('data-clicked', 'true');
                              videoClick();
                          }
                      });
                  }

              }
          };

          // Pagination
          if (galleryConfig.dots) {
              config.pagination.el = galleryConfig.pagination;
          }
          // Loop
          if (galleryConfig.loop == "true") {
              config.loop = true;
          } else {
              config.loop = false;
          }

          // If prev/next element
          if (galleryConfig?.nav) {
              config.navigation.prevEl = galleryConfig.prevEl;
              config.navigation.nextEl = galleryConfig.nextEl;
          }

          // direction
          if (galleryConfig.direction) {
              config.direction = galleryConfig.direction;
          }

          // per view
          if (galleryConfig?.slidesPerView > 1) {
            config.slidesPerView = galleryConfig.slidesPerView;
          }


          // if thumbs
          if (thumbs) {
              config.thumbs.swiper = thumbs;
          }

          //autoplay
          if (galleryConfig.autoplay == "true") {
              config.autoplay = {
                  delay: galleryConfig.delay || 4000,
              };
          }

          // Breakpoints
          if (galleryConfig.breakpoints) {
              config.breakpoints = JSON.parse(galleryConfig.breakpoints);
          }


          // allowTouchMove
          if (galleryConfig.allowTouchMove == "true") {
              config.allowTouchMove = true;
          } else {
              config.allowTouchMove = false;
          }

          return config;
      }

      // remove duplicate slider
      removeDuplicateSlides(slides) {
          slides.forEach(function (slide) {
              if (slide.classList.contains("swiper-slide-duplicate")) {
                  slide.remove();
              }
          });
      }

      // Initlize swiper slider with thums
      initSwiperWithThumbs() {
          // Thumbnails
          var sliderThumbs = document.querySelector(`${this.config["thumbsId"]}`);

          // Thumbnails initialize
          var thumbs;
          if (sliderThumbs) {
              var thumbConfig = sliderThumbs.dataset;
              thumbConfig = this.thumbConfig(thumbConfig);
              // Thumbnails
              thumbs = new Swiper(sliderThumbs, thumbConfig);
          }

          if (this.swiperContainer) {
              var galleryConfig = this.galleryConfiguration(this.config, thumbs);

              // Add click event listener to the swiper slider
              var gallerySl = new Swiper(this.swiperContainer, galleryConfig);


              // Add an event listener to the gallery swiper's 'slideChange' event
              if (thumbs) {
                  thumbs.params.slideToClickedSlide = true;

                  // Remove loop
                  var totalSlides = 0;
                  thumbs.slides.forEach(function (slide) {
                      if (!slide.classList.contains("swiper-slide-duplicate")) {
                          totalSlides++;
                      }
                  });

                  if (totalSlides === thumbs.params.slidesPerView) {
                      thumbs.params.loop = false;
                      gallerySl.params.loop = false;
                      this.removeDuplicateSlides(thumbs.slides);
                      this.removeDuplicateSlides(gallerySl.slides);
                      thumbs.update();
                      gallerySl.update();
                  }

                  gallerySl.on("slideChange", function () {
                      if (thumbs.params.slidesPerView === 1.5) {
                          // Get the active slide index of the gallery swiper
                          var activeSlideIndex = gallerySl.activeIndex;

                          // Calculate the corresponding active thumbnail slide index
                          var activeThumbnailIndex = Math.floor(activeSlideIndex * 1.5);

                          if (activeThumbnailIndex - activeSlideIndex > 1) {
                              activeThumbnailIndex = activeThumbnailIndex - 1;
                          }

                          // Slide to the active thumbnail slide to make it fully visible
                          thumbs.slideTo(activeThumbnailIndex);
                      }
                  });
              }
          }
      }
  }
  customElements.define("swiper-slider", SwiperSlider);
}


// smooth scroll

function live(selector, event, callback, context) {
			/****Helper Functions****/
			// helper for enabling IE 8 event bindings
			function addEvent(el, type, handler) {
				if (el.attachEvent) el.attachEvent("on" + type, handler);
				else el.addEventListener(type, handler);
			}
			// matches polyfill
			this &&
				this.Element &&
				(function (ElementPrototype) {
					ElementPrototype.matches =
						ElementPrototype.matches ||
						ElementPrototype.matchesSelector ||
						ElementPrototype.webkitMatchesSelector ||
						ElementPrototype.msMatchesSelector ||
						function (selector) {
							var node = this,
								nodes = (node.parentNode || node.document).querySelectorAll(selector),
								i = -1;
							while (nodes[++i] && nodes[i] != node);
							return !!nodes[i];
						};
				})(Element.prototype);
			// live binding helper using matchesSelector
			function live(selector, event, callback, context) {
				addEvent(context || document, event, function (e) {
					var found,
						el = e.target || e.srcElement;
					while (el && el.matches && el !== context && !(found = el.matches(selector))) el = el.parentElement;
					if (found) callback.call(el, e);
				});
			}
			live(selector, event, callback, context);
		}

		var fnc_scrollto = function (to, id) {
			var smoothScrollFeature = "scrollBehavior" in document.documentElement.style;
			var articles = document.querySelectorAll("ul#content > li"),
				i;
			if (to == "elem") to = articles[id].offsetTop;
			var i = parseInt(window.pageYOffset);
			if (i != to) {
				if (!smoothScrollFeature) {
					 to = parseInt(to) - 70;    // we can adjust the position
					if (i < to) {
						var int = setInterval(function () {
							if (i > to - 20) i += 1;
							else if (i > to - 40) i += 3;
							else if (i > to - 80) i += 8;
							else if (i > to - 160) i += 18;
							else if (i > to - 200) i += 24;
							else if (i > to - 300) i += 40;
							else i += 60;
							window.scroll(0, i);
							if (i >= to) clearInterval(int);
						}, 10);
					} else {
						var int = setInterval(function () {
							if (i < to + 20) i -= 1;
							else if (i < to + 40) i -= 3;
							else if (i < to + 80) i -= 8;
							else if (i < to + 160) i -= 18;
							else if (i < to + 200) i -= 24;
							else if (i < to + 300) i -= 40;
							else i -= 60;
							window.scroll(0, i);
							if (i <= to) clearInterval(int);
						}, 10);
					}
				} else {
					window.scroll({
						top: to - 70,  // we can adjust the position
						left: 0,
						behavior: "smooth",
					});
				}
			}
          
		};
          

      live(".product_jumpTo.how_to_use p", "click", function (event) {
        event.preventDefault();
				var top = document.querySelector('[id*="product_feature_tile"]').offsetTop;
				fnc_scrollto(top);
			});

                live(".product_jumpTo.compare p", "click", function (event) {
               event.preventDefault();
        var top2 = document.querySelector('[id*="comparison_table"]').offsetTop;
				fnc_scrollto(top2);
			});

            live(".product_jumpTo.technology p", "click", function (event) {
        event.preventDefault();
				var top = document.querySelector('[id*="product_tab_sec"]').offsetTop;
				fnc_scrollto(top);
			});
          
            live(".product_jumpTo.faq p", "click", function (event) {
        event.preventDefault();
				var top = document.querySelector('[id*="pdp_faq"]').offsetTop;
				fnc_scrollto(top);
			});

            live(".product_jumpTo.reviews p", "click", function (event) {
        event.preventDefault();
				var top = document.querySelector('[id*="product_reviews"]').offsetTop;
				fnc_scrollto(top);
			});
        live("#slider-review > div > a", "click", function (event) {
        event.preventDefault();
				var top = document.querySelector('#shopify-section-template--15213323649127__rich_text_hmqyFC').offsetTop;
				fnc_scrollto(top);
			});

